/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-disable import/no-unresolved, import/default */

import ruleChainFieldsetTemplate from './rulechain-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function RuleChainDirective($compile, $templateCache, $mdDialog, $document, $q, $translate, types, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(ruleChainFieldsetTemplate);
        element.html(template);

        scope.onRuleChainIdCopied = function() {
            toast.showSuccess($translate.instant('rulechain.idCopiedMessage'), 750, angular.element(element).parent().parent(), 'bottom left');
        };

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            ruleChain: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '=',
            onSetRootRuleChain: '&',
            onExportRuleChain: '&',
            onDeleteRuleChain: '&'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/rulechain/rulechain.directive.js